module.exports = __webpack_public_path__ + "static/fonts/Cactus-BoldItalic-de449b0d1ce574a3fd2d3104af3e5e67.otf";